// extracted by mini-css-extract-plugin
module.exports = {"wincalc-type":"window-element_wincalc-type__11nn3","wincalc-type-selector":"window-element_wincalc-type-selector__3IjI2","label-title":"window-element_label-title__3JvHQ"};